var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95 12.0375L13.2375 6.75L12.1875 5.7L7.95 9.9375L5.8125 7.8L4.7625 8.85L7.95 12.0375ZM3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39687 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39687 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H6.9C7.0625 1.8 7.33438 1.4375 7.71563 1.1625C8.09688 0.8875 8.525 0.75 9 0.75C9.475 0.75 9.90313 0.8875 10.2844 1.1625C10.6656 1.4375 10.9375 1.8 11.1 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM9 3.1875C9.1625 3.1875 9.29688 3.13438 9.40313 3.02813C9.50938 2.92188 9.5625 2.7875 9.5625 2.625C9.5625 2.4625 9.50938 2.32813 9.40313 2.22188C9.29688 2.11563 9.1625 2.0625 9 2.0625C8.8375 2.0625 8.70313 2.11563 8.59688 2.22188C8.49063 2.32813 8.4375 2.4625 8.4375 2.625C8.4375 2.7875 8.49063 2.92188 8.59688 3.02813C8.70313 3.13438 8.8375 3.1875 9 3.1875Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedTick);
export default __webpack_public_path__ + "static/media/approvedTick.3688985851a80a75d33c4d87192a8c07.svg";
export { ForwardRef as ReactComponent };